import type { BryntumGanttProps } from "@bryntum/gantt-react-thin";
import { TaskType } from "./prop-types";
import type { MutableRefObject } from "react";
import type { Sorter } from "@bryntum/core-thin";

export const onGridRowBeforeDropFinalize: BryntumGanttProps["onGridRowBeforeDropFinalize"] = ({
   context,
}) => {
   const { oldPositionContext, parent } = context;
   const parentType = parent.getData("type");

   // Disallow user from dropping a task another task of the same type
   const droppingIntoSameTaskType = oldPositionContext.some(
      (oldPosition: any) => oldPosition.record.getData("type") === parentType,
   );
   if (droppingIntoSameTaskType) return false;

   // If user is dragging any categories, they must drop them in a project
   const droppingSomeCategories = oldPositionContext.some(
      (oldPosition: any) => oldPosition.record.getData("type") === TaskType.CATEGORY,
   );
   if (droppingSomeCategories && parentType !== TaskType.PROJECT) return false;

   // If user is dragging any subcategories, they must drop them in a category
   const droppingSomeSubcategories = oldPositionContext.some(
      (oldPosition: any) => oldPosition.record.getData("type") === TaskType.SUBCATEGORY,
   );
   if (droppingSomeSubcategories && parentType !== TaskType.CATEGORY) return false;

   // Disallow user from dropping projects anywhere
   const droppingSomeProjects = oldPositionContext.some(
      (oldPosition: any) => oldPosition.record.getData("type") === TaskType.PROJECT,
   );
   if (droppingSomeProjects) return false;
};

export async function handleBeforeSort(
   sorters: Sorter[],
   sortDirection: MutableRefObject<string>,
   projectSort: MutableRefObject<string>,
   skip: MutableRefObject<number>,
   fetchData: () => Promise<void>,
) {
   const sortFields = sorters.map((sorter: Sorter) => sorter.field);
   if (sortFields.includes("name")) {
      skip.current = 0;
      sortDirection.current = sorters.find((sorter) => sorter.field === "name")?.ascending
         ? "asc"
         : "desc";
      projectSort.current = "name";
      await fetchData();
   } else if (sortFields.includes("startDate")) {
      skip.current = 0;
      sortDirection.current = sorters.find((sorter) => sorter.field === "startDate")?.ascending
         ? "asc"
         : "desc";
      projectSort.current = "earliest-start-date";
      await fetchData();
   } else if (sortFields.includes("endDate")) {
      skip.current = 0;
      sortDirection.current = sorters.find((sorter) => sorter.field === "endDate")?.ascending
         ? "asc"
         : "desc";
      projectSort.current = "earliest-end-date";
      await fetchData();
   }
}
